import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
  CreateUpdateDisputeIssueBaseDto,
  DisputeCaseBaseDto,
  DisputeCaseType,
  DisputeIssueBaseDto,
} from "src/app/shared/models/dispute-resolution/dispute-base-models";
import { NotificationService } from "src/app/shared/services/notification.service";
import { CreateUpdateStateComplaintIssueDto } from "src/app/shared/models/dispute-resolution/state-complaint-models";

@Component({
  selector: "app-add-edit-issue",
  templateUrl: "./add-edit-issue.component.html",
  styleUrls: ["./add-edit-issue.component.scss"],
  standalone: false,
})
export class AddEditIssueComponent {
  form: FormGroup;

  disputeCase: DisputeCaseBaseDto;
  issue: DisputeIssueBaseDto;

  isEditMode: boolean = false;

  constructor(
    private notificationService: NotificationService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AddEditIssueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { disputeCase: DisputeCaseBaseDto; issue: DisputeIssueBaseDto }
  ) {
    this.disputeCase = data.disputeCase || null;
    this.issue = data.issue || null;
  }

  ngOnInit() {
    this.isEditMode = this.issue && this.issue.id ? true : false;

    this.form = this.fb.group({
      allegedIssue: this.issue?.allegedIssue || "",
      supportingFacts: this.issue?.supportFacts || "",
      proposedResolution: this.issue?.proposedResolution || "",
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  onSave() {
    if (this.form.valid) {
      // Check if all form fields are empty before mapping
      const values = this.form.getRawValue();
      const isEmpty = Object.values(values).every(
        (v) => v === undefined || v === null || v === "" || v === false
      );
      if (isEmpty) {
        this.notificationService.error(
          "Cannot save an empty party. Please fill out at least one field."
        );
        return;
      }
      const issueData = this.mapIssuePayloadFromForm();
      this.dialogRef.close(issueData);
    } else {
      this.form.markAllAsTouched();
      this.notificationService.error("Please fix errors before saving.");
    }
  }

  private mapIssuePayloadFromForm(): CreateUpdateDisputeIssueBaseDto {
    if (this.disputeCase.disputeCaseType === DisputeCaseType.StateComplaint) {
      return {
        id: this.issue?.id || undefined,
        disputeCaseId: this.disputeCase.id,
        allegedIssue: this.form.get("allegedIssue")?.value,
        supportFacts: this.form.get("supportingFacts")?.value,
        proposedResolution: this.form.get("proposedResolution")?.value,
      } as CreateUpdateStateComplaintIssueDto;
    }
  }
}
